<div class="container">
  <div class="search-section">
    <span class="p-input-icon-left">
      <i class="pi pi-search"></i>
      <input pInputText type="text" [(ngModel)]="searchKey" placeholder="Search.." class="p-inputtext-sm" (keyup.enter)="searchReceipt()"/>
      <p-button icon="pi pi-search" (onClick)="searchReceipt()" [style]="{'margin': '5px', 'height': '35px', 'line-height': '50px'}" [raised]="true" [size]="'small'" severity="info"></p-button>
    </span>
  </div>
  <p-button icon="pi pi-refresh" size="small" (onClick)="refreshData()" [rounded]="true" severity="info" class="refresh-button"></p-button>
</div>

     <p-table #dt1 [value]="POReceiptList" [scrollable]="true" scrollHeight="613px" styleClass="p-datatable-striped"
            responsiveLayout="scroll" class="w-full m-5" styleClass="p-datatable-sm " [paginator]="true" [rows]="10"
            (onPage)="loadReceipt($event)" [(selection)]="selectedPOrder"
            [globalFilterFields]="['poReceiptNumber','vendor.vendorCode','vendor.vendorName','purchaseOrderNumber']"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [rowsPerPageOptions]="[10 ,15, 20]">
            <ng-template pTemplate="header">
            <tr>
                    <th style="width: 4rem">
                        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                    </th>
                    <th>Receipt Number</th>
                    <th>Challan No</th>
                    <th>PO Number</th>
                    <th>Vendor Name</th>
                    <th>Unit Name</th>
                    <th class="text-right">Receipt Amount(₹)</th>
                    <th>Received Date</th>
                    <th>Created By</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-receipt>
            <tr (click)="SelectOption(receipt)">
                    <td>
                     <p-tableRadioButton [value]="receipt"></p-tableRadioButton>
                    </td>
                    <td> {{receipt.poReceiptNumber}}</td>
                    <td>{{receipt.challenNo}}</td>
                    <td>{{receipt.purchaseOrderNumber}}</td>
                    <td>{{receipt.vendor.vendorName}}</td>
                    <td>{{receipt.warehouse.warehouseName}}</td>
                    <td class="text-right">{{ receipt.receiptAmount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2})}}</td>
                    <td>{{receipt.receiveDate | date: 'dd/MM/yy' }}</td>
                    <td>{{receipt.createdBy}}</td>

            </tr>
        </ng-template>
    </p-table>
